import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router } from '@angular/router';
import { ConstantsService } from '../constants/constants.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class IdleService {

  // Public visitor routes (no login required)
  private visitorRoutes: string[] = [
    '/scan-qr-visit-form',
    '/visit-invite-form',
    '/visitor-badge'
  ];

  constructor(
    private idle: Idle,
    private router: Router,
    private constants: ConstantsService,
    private toastr: ToastrService
  ) {
    this.initIdleTimeout();
  }

  initIdleTimeout() {
    this.idle.setIdle(1800); // 29 minutes
    this.idle.setTimeout(60); // 1-minute warning
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // Timeout Event
    this.idle.onTimeout.subscribe(() => {
      const isVisitorRoute = this.visitorRoutes.some(route =>
        this.router.url.includes(route)
      );

      if (!isVisitorRoute) {
        // Logout only for logged-in users
        this.toastr.info('You have been logged out due to inactivity.', 'Session Timeout');
        this.stopIdleWatch();
        this.constants.clearSession();
        this.router.navigate(['/login']);
      }

      // If visitor route → do nothing
    });

    this.idle.watch();
  }

  stopIdleWatch() {
    this.idle.stop();
  }

  resetIdleWatch() {
    this.idle.stop();
    this.idle.watch();
  }
}
